import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import OpThumbnail from 'components/Common/op-ui-wrappers/OpThumbnail/OpThumbnail';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import isDesktop from 'store/app/selector/isDesktop';
import BaseSelector from '../BaseSelector/BaseSelector';
import { BasketItemSelectorProps } from '../types';
import useAvailableSelectorsHook from '../useAvailableSelectorsHook';
import styles from './BasketItemFrameSelector.module.scss';

const BasketItemFrameSelector: FC<BasketItemSelectorProps> = ({ onChangeSelector, orderItemId, selector }) => {
  const { t } = useTranslation();
  const { getSelectors, selectors, loading, selectedSelector, setSelectedSelector } = useAvailableSelectorsHook(
    orderItemId,
    'abstract',
  );

  const [frameApplied, setFrameApplied] = useState(false);
  const isDesktopDevice = useSelector(isDesktop);

  const removeFrame = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    onChangeSelector(orderItemId, null);
    setFrameApplied(false);
  };

  return (
    <BaseSelector
      actionString={t('opeh_add_frame')}
      buttonHeading={t('txt_frame_poster')}
      thumbnail=""
      title={t('txt_add_poster')}
      selectorApplied={frameApplied}
      applySelector={() => {}}
      removeSelector={removeFrame}
      type="complex"
      onContentOpen={() => {
        getSelectors();
      }}
    >
      {loading && <div>Loading...</div>}
      {!loading && (
        <div className={styles.content}>
          <div className={styles.optionsDetails}>
            <div className={styles.frameName}>
              <OpText size={isDesktopDevice ? 'medium' : 'large'} variant="body">
                {selectedSelector?.name}
              </OpText>
            </div>
            <div className={styles.framePrice}>
              <OpText size="small" variant="title">
                <div
                  className={styles.priceInitial}
                  dangerouslySetInnerHTML={{ __html: selectedSelector?.price?.initial?.formatted || '' }}
                />
              </OpText>
              <OpText size="small" variant="title">
                <div
                  className={styles.priceDiscounted}
                  dangerouslySetInnerHTML={{ __html: selectedSelector?.price?.discount?.formatted || '' }}
                />
              </OpText>
            </div>
            <div className={styles.frameDescription}>
              <OpText size="small" variant={isDesktopDevice ? 'body' : 'title'}>
                {selectedSelector?.description}
              </OpText>
            </div>
          </div>
          <div className={styles.frames}>
            <div className={styles.selectedFramePreview}>
              <OpThumbnail src={selectedSelector?.thumbnailUrl || ''} size="fluid" />
            </div>
            <div className={styles.framesGrid}>
              {selectors.map((frame) => (
                <div key={frame?.name} onClick={() => setSelectedSelector(frame)}>
                  <OpThumbnail
                    selected={frame?.name === selectedSelector?.name}
                    src={frame?.thumbnailUrl || ''}
                    alt={frame?.name || ''}
                    size="small-2x"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </BaseSelector>
  );
};

export default BasketItemFrameSelector;
